import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../../login_services/login.service';
import { UUID } from 'angular2-uuid';
import { GoogleAnalyticsEventsService } from '../../../google-analytics-events-service';
import { MatDialog } from '@angular/material';
import { Title } from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import { CommonApiService } from '../../../common-api/common-api.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';
@Component({
  selector: 'app-with-social',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  public login_form: FormGroup;
  password: string = '';
  email: string = '';
  login_flag: string;
  errorMessage: string = '';
  hide = true;
  spinner_div: any = "none";
  term_conditon_data: any;
  auth_key: any;
  session_id: any;
  device_id: any;
  login_btn: boolean = true;
  email_div: any = "block";
  password_div: any = "none";
  captcha_div: any = "none";
  organization_list: any=[];
  sos_login_flag: boolean;
  auth_user: any;
  param: any;
  dynamic_label='Password';
  datastream_flag: boolean;
  favIcon: HTMLLinkElement = document.querySelector('#appIcon');
  mahd_flag: boolean;
  sportz_village_flag: boolean;
  al_hilal_flag: boolean;
  al_shabab_flag: boolean;
  yalla_goal_flag: boolean;
  sports_pad_flag:boolean;
  captchaResponse: string;
  captchaToken: string;
  auth_Captcha_token: any;


  constructor(private fb: FormBuilder, public dialog: MatDialog, private router: Router,
    private login_service: LoginService, public googleAnalyticsEventsService: GoogleAnalyticsEventsService,
    private route:ActivatedRoute,private titleService: Title,private translate:TranslateService,
    private commonApiService:CommonApiService,private recaptchaV3Service: ReCaptchaV3Service) {

      translate.addLangs(['en', 'hi']);
      // translate.setDefaultLang('en');
  
      // const browserLang = translate.getBrowserLang();
      const browserLang = sessionStorage.getItem("locale")!=null?sessionStorage.getItem("locale"):'en';
      translate.use(browserLang.match(/en|hi/) ? browserLang : 'en');

      switch (this.router.url.split('?')[0]) {
        case '/sos-login':
          this.sos_login_flag=true;   
          this.titleService.setTitle('Acadware Admin');   
          break;
        case '/dataStream-login':
          this.datastream_flag=true; 
          this.favIcon.href = 'assets/images/DSWeb.png'; 
          this.titleService.setTitle('DS-ERP');  
          break;

        case '/mahd-login':
          this.mahd_flag=true; 
          this.favIcon.href = 'assets/images/MahdWeb.png'; 
          this.titleService.setTitle('Mahd Sports Academy');
          break;

        case '/sportz-village-login':
          this.sportz_village_flag=true; 
          this.favIcon.href = 'assets/images/SV.png'; 
          this.titleService.setTitle('Sportz Village Academies');  
          break;

        case '/al-hilal-login':         
            this.al_hilal_flag=true; 
            this.favIcon.href = 'assets/images/alhilal-logo.png'; 
            this.titleService.setTitle('AL Hilal FC');  
          break;


        case '/al-Shabab-login':         
          this.al_shabab_flag=true; 
          this.favIcon.href = 'assets/images/shabab-logo.png'; 
          this.titleService.setTitle('AL Shabab FC');  
          break;


        case '/yalla-goal-login':  
          this.yalla_goal_flag=true; 
          this.favIcon.href = 'assets/images/yalla_goal_logo.png'; 
          this.titleService.setTitle('Yalla Goal Academy');  
          break;

        case '/sports-pad-login':  
          this.sports_pad_flag=true; 
          this.favIcon.href = 'assets/images/sportspadfavicon.png'; 
          this.titleService.setTitle('SportsPad');  
          break;


          
      
        default:
          this.sos_login_flag=false;
          this.datastream_flag=false;
          this.mahd_flag=false; 
          this.sportz_village_flag=false;
          this.al_hilal_flag=false;
          this.al_shabab_flag=false;
          this.yalla_goal_flag=false;
          this.sports_pad_flag=false;
          this.favIcon.href = 'favicon.ico';
          this.titleService.setTitle('Acadware Admin');  
          break;
      }
    
 
      
      
      sessionStorage.setItem('sos_login_flag', this.sos_login_flag==true?'Y':'N');
      sessionStorage.setItem('datastream_flag', this.datastream_flag==true?'Y':'N');
      sessionStorage.setItem('mahd_flag', this.mahd_flag==true?'Y':'N');
      sessionStorage.setItem('sportz_village_flag', this.sportz_village_flag==true?'Y':'N');
      sessionStorage.setItem('al_hilal_flag', this.al_hilal_flag==true?'Y':'N');
      sessionStorage.setItem('al_shabab_flag', this.al_shabab_flag==true?'Y':'N');
      sessionStorage.setItem('yalla_goal_flag', this.yalla_goal_flag==true?'Y':'N');
      sessionStorage.setItem('sports_pad_flag', this.sports_pad_flag==true?'Y':'N');
      this.generateSessionID();   

  }
  ngOnInit() {

    this.login_form = this.fb.group({
    //Email: [null, Validators.compose([Validators.required, Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}|(\d{10})$/)])],
    //Allowing user to enter 8 | 10 digit mobile number 
      Email: [null, Validators.compose([Validators.required, Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}|(\d{8}|\d{10})$/)])],
      Password: [null, Validators.required],
    });
    
    this.route.queryParams.subscribe(params => {      
      this.param=params;
  });
    if(this.param['flag']=='m'){
      this.login_flag=this.param['flag'];
      this.dynamic_label='OTP';
      this.login_form.get('Email').setValue(this.param['id']);
      this.checkUserId(this.login_form.value);
    }
    if(this.param['flag']=='e'){
      this.login_form.get('Email').setValue(this.param['id']);
      this.login_flag=this.param['flag'];
      this.checkUserId(this.login_form.value);
    }
   
  }

  generateSessionID() {
    const uuid = UUID.UUID();
    this.session_id = uuid;
    this.device_id = uuid;
    localStorage.setItem("device_id", this.device_id);
      localStorage.setItem("session_id", this.session_id);
    if (this.device_id != null && this.session_id != null) {
      this.login_btn = false;
    }
  }

  checkUserId(login_form) {
    
    // sessionStorage.clear();
    this.recaptchaV3Service.execute('submit')
    .subscribe((token: string) => {
      this.verifyCaptcha(token);
    });
    
    this.spinner_div = "block";
    if (this.login_form.get('Email').valid) {
      this.email = login_form.Email;
      localStorage.setItem('userMail', this.email);
      
    // this.checkEnteredIDAuthentication();
    }
    else {
      this.spinner_div = "none";
    }
  }

  checkEnteredIDAuthentication() {
    
    this.login_service.checkCredentials(this.email, this.login_flag).subscribe(
      response => {
        if (response['status']==200) {
          this.spinner_div = "none";
          this.auth_key = response['data']['auth_key'];
          
          if (response['data']['is_registered'] == 'no' && response['data']['user_state'] == 'Valid') {
           
                  this.spinner_div = "none";
                  sessionStorage.setItem('sos_login_flag', this.sos_login_flag==true?'Y':'N');  
                  sessionStorage.setItem('datastream_flag', this.datastream_flag==true?'Y':'N');         
                  sessionStorage.setItem('mahd_flag', this.mahd_flag==true?'Y':'N');  
                  sessionStorage.setItem('sportz_village_flag', this.sportz_village_flag==true?'Y':'N');  
                  sessionStorage.setItem('al_hilal_flag', this.al_hilal_flag==true?'Y':'N');    
                  sessionStorage.setItem('al_shabab_flag', this.al_shabab_flag==true?'Y':'N'); 
                  sessionStorage.setItem('yalla_goal_flag', this.yalla_goal_flag==true?'Y':'N');
                  sessionStorage.setItem('sports_pad_flag', this.sports_pad_flag==true?'Y':'N');
                  sessionStorage.setItem('set_password_token', response['data']['set_password_token']);
                  this.router.navigate(['resetPassword']);
              
          }
          if (response['data']['is_registered'] == 'yes' && response['data']['user_state'] == 'Valid') {            
            this.email_div = 'none';
            this.password_div = 'block';
            this.auth_user=response;
          }
          if (response['data']['is_registered'] == 'no' && response['data']['user_state'] == 'Invalid') {
            this.errorMessage = "Please enter registered email id / mobile";
          }

          if (response['data']['is_registered'] == 'no' && response['data']['user_state'] == 'Inactive') {
            this.errorMessage = "Email Id is not activated";
          }
        }
        if(response['status']==400) {
          this.errorMessage = response['data']['validation_messages']['email_address'];
        }
      },
    );
  }

 
  addPost(post) {
    if (this.login_form.valid) {
    this.login_btn=true;
    this.spinner_div = "block";
    this.password = post.Password;
    this.email = post.Email;
    localStorage.setItem('userMail', this.email); 
        if (this.auth_user['status']==200) {
          
        

                if (this.auth_user['data']['forgot_password_flag'] == "yes" && this.auth_user['data']['is_registered'] == "yes") 
                { 
                  this.login_service.checkCredentialsV3(this.email, this.password, this.login_flag,this.dynamic_label).subscribe(
                    msg => {
                      
                      if(msg['status']==200){
                        localStorage.setItem('access_token', msg['data']['access_token']);
                        localStorage.setItem('refresh_token', msg['data']['refresh_token']);
                        this.spinner_div = "none";
                        sessionStorage.setItem('sos_login_flag', this.sos_login_flag==true?'Y':'N');  
                        sessionStorage.setItem('datastream_flag', this.datastream_flag==true?'Y':'N');   
                        sessionStorage.setItem('mahd_flag', this.mahd_flag==true?'Y':'N');  
                        sessionStorage.setItem('sportz_village_flag', this.sportz_village_flag==true?'Y':'N'); 
                        sessionStorage.setItem('al_hilal_flag', this.al_hilal_flag==true?'Y':'N');    
                        sessionStorage.setItem('al_shabab_flag', this.al_shabab_flag==true?'Y':'N');             
                        sessionStorage.setItem('yalla_goal_flag', this.yalla_goal_flag==true?'Y':'N'); 
                        sessionStorage.setItem('sports_pad_flag', this.sports_pad_flag==true?'Y':'N');
                        sessionStorage.setItem('set_password_token', this.auth_user['data']['set_password_token']);
                        this.router.navigate(['resetPassword']);
                      }
                    },
                    error =>{        
                      if(error['status']==401){                        
                        this.errorMessage = error['error']['message'];
                        this.spinner_div = "none";
                      }});
                }
                else if (this.auth_user['data']['is_registered']="yes" && this.auth_user['data']['user_state'] == "Valid" 
                && this.auth_user['data']['forgot_password_flag'] != "yes") 
                 {
                  this.login_service.checkCredentialsV3(this.email, this.password, this.login_flag,this.dynamic_label).subscribe(
                    msg => {
                      if(msg['status']==200){
                        localStorage.setItem('access_token', msg['data']['access_token']);
                        localStorage.setItem('refresh_token', msg['data']['refresh_token']);

                        this.login_service.checkAuthorization(this.auth_user['data']['customers'][0].customer_id).subscribe(
                          success => {
                            
                            if (success) { 
                              this.login_btn=false;                   
                              localStorage.setItem('Profile_img', this.auth_user['data']['customers'][0].academy_original_image_folder_path);
                              localStorage.setItem('UserName', this.auth_user['data']['customers'][0].first_name + " " + this.auth_user['data']['customers'][0].last_name);
                              localStorage.setItem('currentUser', this.auth_user['data']['customers'][0].customer_id);
      
                              // this.googleAnalyticsEventsService.emitEvent("AcadWare Analytics", "User navigation", "Customer ID", this.auth_user['data']['customers'][0].customer_id);
      
                              this.login_service.getOrganizationList(this.auth_user['data']['customers'][0].customer_id).subscribe(
                                response1 => {            
                                  
                                    if (response1['organization_list'].length != 0) {
                                      
                                      sessionStorage.setItem('sos_login_flag', this.sos_login_flag==true?'Y':'N');
                                      sessionStorage.setItem('datastream_flag', this.datastream_flag==true?'Y':'N');
                                      sessionStorage.setItem('mahd_flag', this.mahd_flag==true?'Y':'N'); 
                                      sessionStorage.setItem('sportz_village_flag', this.sportz_village_flag==true?'Y':'N');
                                      sessionStorage.setItem('al_hilal_flag', this.al_hilal_flag==true?'Y':'N');
                                      sessionStorage.setItem('al_shabab_flag', this.al_shabab_flag==true?'Y':'N');
                                      sessionStorage.setItem('yalla_goal_flag', this.yalla_goal_flag==true?'Y':'N'); 
                                      sessionStorage.setItem('sports_pad_flag', this.sports_pad_flag==true?'Y':'N');
                                      this.spinner_div = "none";
                                      if (response1['is_admin']) {
                                        localStorage.setItem('is_Admin', '1');
                                      }
                                      else {
                                        localStorage.setItem('is_Admin', '0');
                                      }
                                      response1['organization_list'].forEach(element => {
                                        var role_id=0;
                                        element['role_types'].forEach(role => {
                                          if(role=="A" || role=="H")
                                          {
                                            role_id=1;
                                          }
                                         
                                          
                                        });
                                        if(role_id==1){
                                          this.organization_list.push(element);
                                        }
                                      });
                                     
                                      if(this.organization_list.length==1){
                                        localStorage.setItem('organization_list', JSON.stringify(this.organization_list));
                                        localStorage.setItem('Organization_list_1',JSON.stringify(this.organization_list));
                                        sessionStorage.setItem('OrganizationID', this.organization_list[0].organization_id);
                                        this.login_service.getChildOrganizations(this.auth_user['data']['customers'][0].customer_id, this.organization_list[0].organization_id).subscribe(
                                          response => {
            
                                            if (response['status'] == 200 && response['data']['organization_details']!=false) {
                                              
                                              if (response['data']['organization_details']['child_academies'].length != 0) {
                                                this.router.navigate(['organization_selector', this.organization_list[0].organization_id]);
                                              }
                                              else { 
                                                this.login_academy(this.organization_list);
                                              }
                                            }
                                            else {
                                              this.login_academy(this.organization_list);
                                            }
                                          });
                                      }
                                      if(this.organization_list.length>1){
                                        localStorage.setItem('organization_list', JSON.stringify(this.organization_list));
                                        this.router.navigate(['organization_selector']);
                                      }
                       
                                    }
                                });
                            }
                            else {
                              this.errorMessage = 'Your registered id does not have the necessary rights to access the site';
                              this.router.navigate(['']);
                            }
                          },
                          error => console.log("Authorization is not working!")
                        );
                      }
                      if(msg['status']==401){
                        this.errorMessage = msg['message'];
                        this.router.navigate(['']);
                      }
                
                  this.spinner_div = "none";
                },
                
                    error =>{        
                      if(error['status']==401){                        
                        this.errorMessage = error['error']['message'];
                        this.spinner_div = "none";
                      }}
                );
                }
                else {
                  this.spinner_div = "none";
                  
                  if (this.auth_user['data']['is_registered']== "yes" && this.auth_user['data']['Password State'] == "Notmatched"
                   && this.auth_user['data']['user_state'] == "Valid") {
                     
                    this.errorMessage = 'Password is incorrect';
                  }
                  else if (this.auth_user['data']['is_registered'] == "no" && this.auth_user['data']['user_state'] == "Invalid"){
                    this.errorMessage = 'Email Id is incorrect';
                  this.router.navigate(['']);
                  }
                    
                }
          
          
        }
    }
    else{
      this.spinner_div = "none";
    }
  }
  usercredentialEnter() {
    this.errorMessage = '';
    this.login_btn=false;
  } 

  checkEmailorMobile(userID) { 
    this.errorMessage = '';
    var email_id_chk = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
    //var phone_no_chk = /^(?:\d{10})$/;
    var phone_no_chk = /^(?:\d{8}|\d{10})$/;
    if (email_id_chk.test(userID) == true) {
      return this.login_flag = 'e';
    }
    if (phone_no_chk.test(userID) == true) {
      return this.login_flag = 'm';
    }
  }
  openTermsCondition() {
    this.router.navigate(['terms-of-use']);
    // this.dialog.open(this.term_conditon,
    //   {      
    //     width:'550px',
    //     disableClose:true,
    //   });    
    //   this.login_service.getUserTermCondition().subscribe(
    //     response => 
    //     {
    //       if(response!='')
    //       {
    //        this.term_conditon_data=response;
    //       }
    //       else
    //       {
    //         console.log('error');
    //       }
    //     },
    //     error => console.log("getUserTermCondition IS NOT WORKING!")
    // );
  }
  sos_term(){
      this.dialog.open(this.term_conditon,
      {      
        width:'550px',
        disableClose:true,
      });    
      this.login_service.getUserTermCondition().subscribe(
        response => 
        {
          if(response!='')
          {
           this.term_conditon_data=response;
          }
          else
          {
            console.log('error');
          }
        },
        error => console.log("getUserTermCondition IS NOT WORKING!")
    );
  }
  changeEmail() {
    this.email_div = "block";
    this.password_div = "none";
    this.errorMessage = '';
    sessionStorage.clear();
  }
  @ViewChild('term_conditon') term_conditon: TemplateRef<any>;
  login_academy(response) {
    var admin = 0;
    var headoffice = 0;
    var admin_role=0;
    var content_creator=0;
    response[0]['role_types'].forEach(element => {
      if (element == 'H') {
        headoffice = 1;
      }
      if (element == 'A') {
        admin = 1;
      }
    });
    response[0]['role_names'].forEach(element => {
      if(element=='Admin')
      {
        admin_role=1;
      }
      if(element=='Content Creator')
      {
        content_creator=1;
      }
    });
    if(admin==1)
    {
      localStorage.setItem('Flag', 'A');
    }
    if(headoffice==1 && admin==0)
    {
      localStorage.setItem('Flag', 'H');
    }    
    sessionStorage.setItem('parent_academy_flag', 'N');    
    if(admin_role==1 || headoffice==1)
    {
      localStorage.setItem('Content_creator_flag', 'N');
      sessionStorage.setItem('sos_login_flag', this.sos_login_flag==true?'Y':'N');
      sessionStorage.setItem('datastream_flag', this.datastream_flag==true?'Y':'N');
      sessionStorage.setItem('mahd_flag', this.mahd_flag==true?'Y':'N'); 
      sessionStorage.setItem('sportz_village_flag', this.sportz_village_flag==true?'Y':'N');
      sessionStorage.setItem('al_hilal_flag', this.al_hilal_flag==true?'Y':'N');
      sessionStorage.setItem('al_shabab_flag', this.al_shabab_flag==true?'Y':'N');
      sessionStorage.setItem('yalla_goal_flag', this.yalla_goal_flag==true?'Y':'N');
      sessionStorage.setItem('sports_pad_flag', this.sports_pad_flag==true?'Y':'N'); 
      this.refreshToken('1');
     
    }
    if(content_creator==1 && admin_role==0)
    {
      localStorage.setItem('Content_creator_flag', 'Y');
      sessionStorage.setItem('sos_login_flag', this.sos_login_flag==true?'Y':'N');
      sessionStorage.setItem('datastream_flag', this.datastream_flag==true?'Y':'N');
      sessionStorage.setItem('mahd_flag', this.mahd_flag==true?'Y':'N'); 
      sessionStorage.setItem('sportz_village_flag', this.sportz_village_flag==true?'Y':'N');
      sessionStorage.setItem('al_hilal_flag', this.al_hilal_flag==true?'Y':'N');
      sessionStorage.setItem('al_shabab_flag', this.al_shabab_flag==true?'Y':'N');
      sessionStorage.setItem('yalla_goal_flag', this.yalla_goal_flag==true?'Y':'N'); 
      sessionStorage.setItem('sports_pad_flag', this.sports_pad_flag==true?'Y':'N');
      this.refreshToken('2');
    }
  }

  forgotPassword(){
    sessionStorage.setItem('sos_login_flag', this.sos_login_flag==true?'Y':'N');
    sessionStorage.setItem('datastream_flag', this.datastream_flag==true?'Y':'N');
    sessionStorage.setItem('mahd_flag', this.mahd_flag==true?'Y':'N'); 
    sessionStorage.setItem('sportz_village_flag', this.sportz_village_flag==true?'Y':'N');
    sessionStorage.setItem('al_hilal_flag', this.al_hilal_flag==true?'Y':'N');
    sessionStorage.setItem('al_shabab_flag', this.al_shabab_flag==true?'Y':'N');
    sessionStorage.setItem('yalla_goal_flag', this.yalla_goal_flag==true?'Y':'N');
    sessionStorage.setItem('sports_pad_flag', this.sports_pad_flag==true?'Y':'N'); 
  }

  
  refreshToken(e){
    this.login_service.refreshTokenApi().subscribe(
      response=>
      {     
        if(response['status']==200)
        {               
          localStorage.setItem('access_token', response['data']['access_token']);
          localStorage.setItem('refresh_token', response['data']['refresh_token']);
          if(e=='1'){
            this.router.navigate(['dashboard'],{ queryParams: { page: 1 }  });
          }
          if(e=='2'){
            this.router.navigate(['/coaching-drill']);
          }
          
        }              
        else
        {
              
        }
      });
  }

  changeLocale(locale:string){
    this.commonApiService.changeLocale(locale);
    
  }

  verifyCaptcha(token: string) {
    this.spinner_div = "block";
    this.captchaToken=token;
    this.login_service.verifyCaptchaDetails(this.captchaToken).subscribe(
    response=>{
      if (response['data']!=false) {
       this.spinner_div = "none";
       this.authCaptchaToken();
      } else {
        console.log('Bot detected! Try again.');
        this.spinner_div = "none";
      }
    },
        error => console.log("get Captcha IS NOT WORKING!")
    )
   
  }

  authCaptchaToken(){
    this.recaptchaV3Service.execute('submit')
    .subscribe((token1: string) => {
      this.captchaTokenForAuth(token1);
    });
  }

  captchaTokenForAuth(token){
    this.auth_Captcha_token=token;
    if (token!=null && token.trim() !== '') { 
      this.auth_Captcha_token = token;
      localStorage.setItem('site_key', this.auth_Captcha_token);
      this.checkEnteredIDAuthentication();
    }
  }
}